import { createSlice } from '@reduxjs/toolkit';

const potentialGraph = createSlice({
  name: 'flowingWaterGraph',
  initialState: {
    hoveredSegmentId: null,
    municipalityFilterId: null,
    isCollapsed: false,
  },
  reducers: {
    setHoveredSegmentId: (state, action) => {
      state.hoveredSegmentId = action.payload ?? null;
    },
    setMunicipalityFilterId: (state, action) => {
      state.municipalityFilterId = action.payload ?? null;
    },
    setGraphCollapsed: (state, action) => {
      state.isCollapsed = Boolean(action.payload);
    },
    resetFlowingWaterGraph: (state) => {
      state.hoveredSegmentId = null;
      state.municipalityFilterId = null;
      state.isCollapsed = false;
    },
  },
});

export const {
  resetFlowingWaterGraph,
  setGraphCollapsed,
  setHoveredSegmentId,
  setMunicipalityFilterId,
} = potentialGraph.actions;

export default potentialGraph.reducer;
